export const SAT_BOOTCAMP_FALL_2022_WAITLIST_NAME = 'sat-bootcamp-fall-2022'
export const SAT_BOOTCAMP_SPRING_2022_WAITLIST_NAME = 'sat-bootcamp-spring-2022'
export const DEADLINE_HOTLINE_FALL_2022_WAITLIST_NAME = 'deadline-hotline-fall-2022'
export const DEADLINE_HOTLINE_FALL_2022_REGISTER_NAME = 'deadline-hotline-fall-2022-register'
export const STARS_COLLEGE_NETWORK_MAILING_LIST_NAME = 'stars-college-network-2023'
export const KA_ALGEBRA_MAR_2024_MAILING_LIST_NAME = 'ka-algebra2-mar-2024'
export const SAT_BOOTCAMP_COUNSELOR_MAR_2024_MAILING_LIST_NAME = 'sat-bootcamp-counselor-mar-2024'

export const WAITLIST_ITEMS = [
  SAT_BOOTCAMP_FALL_2022_WAITLIST_NAME,
  DEADLINE_HOTLINE_FALL_2022_WAITLIST_NAME,
  DEADLINE_HOTLINE_FALL_2022_REGISTER_NAME,
  SAT_BOOTCAMP_SPRING_2022_WAITLIST_NAME,
  STARS_COLLEGE_NETWORK_MAILING_LIST_NAME,
  KA_ALGEBRA_MAR_2024_MAILING_LIST_NAME,
  SAT_BOOTCAMP_COUNSELOR_MAR_2024_MAILING_LIST_NAME,
] as const

export const WAITLIST_PREFIXES = ['sat-bootcamp', 'caw', 'learning-labs', 'dialogues'] as const
